import React, { useState, useEffect } from 'react';
import { Alert } from 'reactstrap';
import { OrderService, getPaymentState } from './../../services/OrderService';
import moment from 'moment';

import { formatMoney } from './../../helpers/formatMoney';

import calendar from '../../assets/images/download.svg';

const TableHistory = ({ shoppingList }) => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const PriceCell = ({ value }) => {
    if (value === undefined || value === null || isNaN(value)) {
      return <span>$ 0</span>;
    }
    return <span>$ {formatMoney(value, 0, 3, '.', ',')}</span>;
  };

  useEffect(() => {
    if (shoppingList) {
      const processedList = shoppingList.map(element => ({
        ...element,
        state: getPaymentState(element.state),
        typeOfPurchase: element.lotteries.length > 0
          ? (element.recharges.length > 0 ? 'Loterías y Recargas' : 'Loterías')
          : 'Recargas',
        orderMontoTotal: element.order?.monto?.total || 0,
      }));
      setData(processedList);
    }
  }, [shoppingList]);

  const handleClickPDF = async (order) => {
    if (!order || !order.order) {
      console.error('Invalid order data:', order);
      return;
    }

    const infOrder = await order.order;


    const orderData = [
      {
        label: 'Resultado de la transacción',
        value: infOrder.estado
      },
      {
        label: 'Nombre del comprador',
        value: `${infOrder.comprador?.name || ''} ${infOrder.comprador?.surname || ''}`
      },
      {
        label: 'Email',
        value: infOrder.comprador?.email || ''
      },
      {
        label: 'Documento',
        value: infOrder.comprador?.document || ''
      },
      {
        label: 'Teléfono',
        value: infOrder.comprador?.mobile || ''
      },
      {
        label: 'Fecha de la transacción',
        value: moment(infOrder.fecha).format('LLL')
      },
      {
        label: 'Moneda',
        value: infOrder.monto?.currency || ''
      },
      {
        label: 'Total pagado',
        value: `$ ${formatMoney(infOrder.monto?.total || 0, 0, 3, '.', ',')}`
      },
      {
        label: 'Banco',
        value: infOrder.banco || ''
      },
      {
        label: 'Referencia',
        value: infOrder.referencia
      },
      {
        label: 'Cus/Autorización',
        value: infOrder.cus || ''
      },
      {
        label: 'Descripción',
        value: infOrder.descripcion || ''
      },
      {
        label: 'Dirección IP',
        value: infOrder.ip || ''
      }

    ];

    if (infOrder.descuento) {
      orderData.splice(7, 0, {
        label: 'Valor total',
        value: `$ ${formatMoney(infOrder.totalSinDescuento, 0, 3, '.', ',')}`
      });
      orderData.splice(8, 0, {
        label: 'Descuento',
        value: `$ ${formatMoney(infOrder.descuento, 0, 3, '.', ',')}`
      });
    } else if (infOrder.monto?.descuento) {
      orderData.splice(7, 0, {
        label: 'Valor total',
        value: `$ ${formatMoney(infOrder.monto.totalSinDescuento, 0, 3, '.', ',')}`
      });
      orderData.splice(8, 0, {
        label: 'Descuento',
        value: `$ ${formatMoney(infOrder.monto.descuento, 0, 3, '.', ',')}`
      });
    }


    OrderService.getPDFOrder(orderData);
  };

  const downloadPdf = async (order) => {
    if (!order || !order.numTransaccion) {
      return;
    }
    const infTransaction = await order;

    const dataBuscarS3 = {
      numTransaccionUsuario: infTransaction.numTransaccion
    };

    OrderService.BuscarS3(dataBuscarS3).then(responseBuscarS3 => {
      if (!responseBuscarS3) {
        alert('Error al descargar el PDF');
        return;
      }
      if (responseBuscarS3.startsWith("http")) {
        const pdfUrl = responseBuscarS3;
        const link = document.createElement('a');
        document.body.appendChild(link);
        link.href = pdfUrl;
        link.target = '_blank';
        link.click();
        if (responseBuscarS3 instanceof Blob) {
          setTimeout(() => {
            window.URL.revokeObjectURL(pdfUrl);
          }, 100);
        }
        link.remove();
      } else {
        const byteCharacters = atob(responseBuscarS3);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = 'compra_' + infTransaction.numTransaccion + '.pdf';
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          URL.revokeObjectURL(blobUrl);
          document.body.removeChild(link);
        }, 1000);

      }
    })
      .catch((responseBuscarS3) => {
        alert("Error al buscar el PDF: " + responseBuscarS3.message);
      });
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(event.target.value);
    setCurrentPage(1);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);


  const getStateClass = (state) => {
    switch (state) {
      case 'PENDIENTE':
        return 'estado-pendiente';
      case 'APROBADO':
        return 'estado-aprobado';
      case 'RECHAZADO':
        return 'estado-rechazado';
      default:
        return '';
    }
  };

  return (
    <section className="table-custom-data table-shopping-history">
      {data.length === 0 && (
        <Alert className="my-2 content-center" color="warning">
          No se han encontrado resultados
        </Alert>
      )}
      {data.length > 0 && (
        <div className='table-full-width'>
          <div className='lotti-table'>
            <div style={{ display: 'flex' }} className='lotti-row header'>
              <div style={{ flex: 1 }} className='header-cell'>No. DE TRANSACCIÓN</div>
              <div style={{ flex: 1 }} className='header-cell'>FECHA</div>
              <div style={{ flex: 1 }} className='header-cell'>TIPO DE COMPRA</div>
              <div style={{ flex: 1 }} className='header-cell'>VALOR</div>
              <div style={{ flex: 1 }} className='header-cell'>ESTADO</div>
              <div style={{ flex: 1 }} className='header-cell'>COLILLA</div>
            </div>

            {currentItems.map((row) => (
              <div className='lotti-row' key={row.id}>
                {row.lotteries.map((lottery) => (
                  <div style={{ display: 'flex' }} className='lotti-row' key={lottery.id}>
                    <div style={{ flex: 1 }} className="body-cell" data-title="No. DE TRANSACCIÓN">{lottery.numTransaccion}</div>
                    <div style={{ flex: 1 }} className='body-cell' data-title="FECHA">{moment(lottery.updatedAt).format('DD/MMM/YYYY').replace('.', '')}</div>
                    <div style={{ flex: 1 }} className='body-cell' data-title="TIPO DE COMPRA">{row.typeOfPurchase}</div>
                    <div style={{ flex: 1 }} className='body-cell' data-title="VALOR"><PriceCell value={lottery.total} /></div>
                    <div style={{ flex: 1 }} className='body-cell ' data-title="ESTADO">
                      <p className={` ${getStateClass(row.state)}`}>
                        {row.state}
                      </p>
                    </div>
                    <div style={{ flex: 1 }} className='body-cell' data-title="COLILLA">
                      <button
                        type="submit"
                        className="btn-download btn-primary"
                        onClick={() => downloadPdf(lottery)}
                        disabled={row.state !== 'APROBADO'}
                      >
                        DESCARGAR
                      </button>
                    </div>
                  </div>
                ))}
              </div >
            ))}
          </div >
          <div style={{ textAlign: 'center', marginTop: '1rem' }} className="pagination-container row">
            <div className='col-12'>
              <button
                className="pagination-btn btn-primary"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Anterior
              </button>
              <span>Página {currentPage}</span>
              <button
                className="pagination-btn btn-primary"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage * itemsPerPage >= data.length}
              >
                Siguiente
              </button>
            </div>
            <div style={{ marginTop: '1rem' }} className='col-12'>
              <select
                onChange={handleItemsPerPageChange}
                value={itemsPerPage}
                className="pagination-select"
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={15}>15</option>
              </select>
            </div>
          </div>
        </div >

      )}
    </section >
  );
};

export default TableHistory;
